import { DeltaServerChangeFeed } from "@hds-products/delta-server-client";
import { EventRuntimeEngineServiceInfoClientEntity } from "../index.mjs";

class EventRuntimeEngineServiceInfoClientChangeFeed extends DeltaServerChangeFeed {
    static DEFAULT_PROJECTION = {};
    constructor(deltaServerClient, baseUri, customHeaderFn, projection = EventRuntimeEngineServiceInfoClientChangeFeed.DEFAULT_PROJECTION) {
        super(EventRuntimeEngineServiceInfoClientEntity, deltaServerClient, baseUri, EventRuntimeEngineServiceInfoClientEntity.prototype._meta.entityName, customHeaderFn, projection);
    }
}
export { EventRuntimeEngineServiceInfoClientChangeFeed };
export default EventRuntimeEngineServiceInfoClientChangeFeed;